module.exports = __webpack_public_path__ + "static/media/download-badge.9842f118.png";